module.exports = __webpack_public_path__ + "static/img/A (32).dab4e175.png";